import { paths } from 'src/routes/paths';

import packageJson from '../package.json';

console.log('Mode:', import.meta.env.VITE_MODE);

// ----------------------------------------------------------------------

export type ConfigValue = {
  sdkZoomClient: string;
  contact: {
    zalo: string;
    smartxAcademy: string;
    email: string;
    hotline: string;
  };
  site: {
    name: string;
    serverUrl: string;
    assetURL: string;
    basePath: string;
    version: string;
  };
  auth: {
    method: 'jwt';
    skip: boolean;
    redirectPath: string;
  };
  firebase: {
    apiKey: string;
    authDomain: string;
    projectId: string;
    storageBucket: string;
    messagingSenderId: string;
    appId: string;
    measurementId: string;
  };
  VAPID_KEY: string;
};

// ----------------------------------------------------------------------

export const CONFIG: ConfigValue = {
  sdkZoomClient: import.meta.env.ZOOM_SDK,
  contact: {
    zalo: import.meta.env.VITE_CONTACT_ZALO ?? '',
    smartxAcademy: import.meta.env.VITE_CONTACT_SMARTX_ACADEMY ?? '',
    email: import.meta.env.VITE_CONTACT_EMAIL ?? '',
    hotline: import.meta.env.VITE_CONTACT_HOTLINE ?? '',
  },
  site: {
    name: 'BAF',
    serverUrl: import.meta.env.VITE_SERVER_URL ?? '',
    assetURL: import.meta.env.VITE_ASSET_URL ?? '',
    basePath: import.meta.env.VITE_BASE_PATH ?? '',
    version: packageJson.version,
  },
  auth: {
    method: 'jwt',
    skip: false,
    redirectPath: paths.client.root,
  },
  firebase: {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
    storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
    appId: import.meta.env.VITE_FIREBASE_APP_ID,
    measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
  },
  VAPID_KEY: import.meta.env.VITE_FIREBASE_VAPID_KEY ?? '',
};
